export const RESET = 'RESET';

// FETCH_EMPLOYEE_PROFILE
export const FETCH_EMPLOYEE_PROFILE_PENDING = 'FETCH_EMPLOYEE_PROFILE_PENDING';
export const FETCH_EMPLOYEE_PROFILE_FULFILLED = 'FETCH_EMPLOYEE_PROFILE_FULFILLED';
export const FETCH_EMPLOYEE_PROFILE_ERROR = 'FETCH_EMPLOYEE_PROFILE_ERROR';

// UPDATE_EMPLOYEE
export const UPDATE_EMPLOYEE_PROFILE_PENDING = 'UPDATE_EMPLOYEE_PROFILE_PENDING';
export const UPDATE_EMPLOYEE_PROFILE_FULFILLED = 'UPDATE_EMPLOYEE_PROFILE_FULFILLED';
export const UPDATE_EMPLOYEE_PROFILE_ERROR = 'UPDATE_EMPLOYEE_PROFILE_ERROR';

// FETCH_RESUME
export const FETCH_RESUME_PENDING = 'FETCH_RESUME_PENDING';
export const FETCH_RESUME_FULFILLED = 'FETCH_RESUME_FULFILLED';
export const FETCH_RESUME_ERROR = 'FETCH_RESUME_ERROR';

// FETCH_RESUME_ITEM
export const FETCH_RESUME_ITEM_PENDING = 'FETCH_RESUME_ITEM_PENDING';
export const FETCH_RESUME_ITEM_FULFILLED = 'FETCH_RESUME_ITEM_FULFILLED';
export const FETCH_RESUME_ITEM_ERROR = 'FETCH_RESUME_ITEM_ERROR';

// STORE_RESUME_ITEM
export const STORE_RESUME_ITEM_PENDING = 'STORE_RESUME_ITEM_PENDING';
export const STORE_RESUME_ITEM_FULFILLED = 'STORE_RESUME_ITEM_FULFILLED';
export const STORE_RESUME_ITEM_ERROR = 'STORE_RESUME_ITEM_ERROR';

// DELETE_RESUME_ITEM
export const DELETE_RESUME_ITEM_PENDING = 'DELETE_RESUME_ITEM_PENDING';
export const DELETE_RESUME_ITEM_FULFILLED = 'DELETE_RESUME_ITEM_FULFILLED';
export const DELETE_RESUME_ITEM_ERROR = 'DELETE_RESUME_ITEM_ERROR';

// FETCH_APPLICATIONS
export const FETCH_APPLICATIONS_PENDING = 'FETCH_APPLICATIONS_PENDING';
export const FETCH_APPLICATIONS_FULFILLED = 'FETCH_APPLICATIONS_FULFILLED';
export const FETCH_APPLICATIONS_ERROR = 'FETCH_APPLICATIONS_ERROR';

// STORE_APPLICATION
export const STORE_APPLICATION_PENDING = 'STORE_APPLICATION_PENDING';
export const STORE_APPLICATION_FULFILLED = 'STORE_APPLICATION_FULFILLED';
export const STORE_APPLICATION_ERROR = 'STORE_APPLICATION_ERROR';

// SAVE_APPLICATION_IN_EDIT
export const SAVE_APPLICATION_IN_EDIT = 'SAVE_APPLICATION_IN_EDIT';

// DELETE_JOB_APPLICATION
export const DELETE_JOB_APPLICATION_PENDING = 'DELETE_JOB_APPLICATION_PENDING';
export const DELETE_JOB_APPLICATION_FULFILLED = 'DELETE_JOB_APPLICATION_FULFILLED';
export const DELETE_JOB_APPLICATION_ERROR = 'DELETE_JOB_APPLICATION_ERROR';

// FETCH_COOPERATION_AGREEMENTS
export const FETCH_COOPERATION_AGREEMENTS_PENDING = 'FETCH_COOPERATION_AGREEMENTS_PENDING';
export const FETCH_COOPERATION_AGREEMENTS_FULFILLED = 'FETCH_COOPERATION_AGREEMENTS_FULFILLED';
export const FETCH_COOPERATION_AGREEMENTS_ERROR = 'FETCH_COOPERATION_AGREEMENTS_ERROR';
